"use client";

import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const services = [{
  id: 1,
  title: "Signature Burgers",
  label: "01",
  description: "Our world-famous smash burgers, crafted with premium halal beef and bold Punjabi spices."
}, {
  id: 2,
  title: "Traditional Karahi",
  label: "02",
  description: "Authentic, slow-cooked karahi dishes that bring the true taste of Lahore to Irving, Texas."
}, {
  id: 3,
  title: "Fusion Platters",
  label: "03",
  description: "The perfect marriage of East and West, featuring spicy masala fries and tandoori wings."
}, {
  id: 4,
  title: "Catering Services",
  label: "04",
  description: "Feed your next event right with our bold flavors. Perfect for weddings, corporate, and parties."
}, {
  id: 5,
  title: "Live Events",
  label: "05",
  description: "Experience the energy of Sultani with live music, community gatherings, and special pop-ups."
}, {
  id: 6,
  title: "Online Ordering",
  label: "06",
  description: "Get your Sultani fix delivered fast or ready for pickup. Bold, delicious, and always halal."
}];
export default function Services() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}